<template>
  <div class="card cardPrimary" v-bind:class="{cardPrimaryWide: isCardWide}" v-if="dataPrimaryCard">
    <div class="card-header">
      <div class="row">
        <div class="col-1">
          <i v-if="dataPrimaryCard.officeTypes === 'kiosk'" class="card__icon dock_icon"></i>
          <i v-if="dataPrimaryCard.officeTypes === 'license'" class="card__icon icon-card"></i>
          <i v-if="dataPrimaryCard.officeTypes === 'plate'" class="card__icon icon-directions-car"></i>
          <i v-if="dataPrimaryCard.officeTypes !== 'license' && dataPrimaryCard.officeTypes !== 'plate' && dataPrimaryCard.officeTypes !== 'kiosk' " class="card__icon icon-government-building"></i>
        </div>

        <div class="col-10">
          <h5>{{ dataPrimaryCard.name }}</h5>
        </div>
      </div>

    </div>

    <div class="card-body">
      <div class="row">

        <!-- For a normal-width card, with no notes, show status -->
        <div class="col" v-if="isCardWide === false">
          <div class="alert alert-danger"
            v-if="dataPrimaryCard.temporaryOfficeStatus === 'Closed'"
          >This location is temporarily closed.</div>

          <div class="alert alert-success"
            color="success"
            v-if="dataPrimaryCard.temporaryOfficeStatus === 'Limited Services'"
          >This location has limited services available at this time.</div>

          <div class="alert alert-warning"
            color="warning"
            v-if="dataPrimaryCard.temporaryOfficeStatus === 'Appointment Only'"
          >This location requires appointments at this time.</div>
          </div>
        </div>

      <div class="row">

        <!-- If this is a wider card, with notes, move to the side column --> 
        <div class="col-sm-5"
           v-if="isCardWide === true">
         
          <!-- Alert statues for wide column -->
          <div class="alert alert-danger"
            v-if="dataPrimaryCard.temporaryOfficeStatus === 'Closed'"
          >This location is temporarily closed.</div>

          <div class="alert alert-success"
            color="success"
            v-if="dataPrimaryCard.temporaryOfficeStatus === 'Limited Services'"
          >This location has limited services available at this time.</div>

          <div class="alert alert-warning"
            color="warning"
            v-if="dataPrimaryCard.temporaryOfficeStatus === 'Appointment Only'"
          >This location requires appointments at this time.</div>
          

            <div class="alert alert-warning" v-if="dataPrimaryCard.notes">
              <em>{{ dataPrimaryCard.notes }}</em>
            </div>
        </div>

        <div class="col">
          <h6>Services</h6>
          <hr />
          <img v-if="dataPrimaryCard.officeTypes === 'kiosk'" src="assets/ncdmv-kiosk-logo.png" alt="NCDMV Express" style="float:right;padding:10px;width:25%" />
          <p>
            <span v-if="dataPrimaryCard.officeTypes === 'kiosk'">
              <i class="icon-services-list"></i> Renew driver licenses/state IDs<br/>
              <i class="icon-services-list"></i> Print Temporary Driver/Identification Certificate<br/>
              <i class="icon-services-list"></i> Order duplicate driver licenses, permits, &amp; state IDs<br/>
              <i class="icon-services-list"></i> Change address<br/>
              <i class="icon-services-list"></i> Register to vote
            </span>

            <span v-if="dataPrimaryCard.officeTypes === 'kiosk' && this.rootStore.lpaKioskAllowed.includes(dataPrimaryCard.counties)">
              <br/>
              <i class="icon-services-list"></i> Renew vehicle registrations<br/>
              <i class="icon-services-list"></i> Order duplicate vehicle registrations<br/>
              <i class="icon-services-list"></i> Print license plate stickers<br/>
            </span>

            <span v-if="dataPrimaryCard.officeTypes === 'license'">
              <i class="icon-services-list"></i> Driver License
            </span>
            <span v-if="dataPrimaryCard.officeTypes === 'plate'">
              <i class="icon-services-list"></i> Plate &amp; Vehicle Registration
            </span>

            <span v-if="dataPrimaryCard.officeTypes === 'irp'">
              <i class="icon-services-list"></i> Commercial Trucking (IRP)
            </span>
            <span v-if="dataPrimaryCard.officeTypes === 'lt'">
              <i class="icon-services-list"></i> License &amp; Theft Bureau
            </span>
            <span v-if="dataPrimaryCard.officeTypes === 'irp,plate'">
              <i class="icon-services-list"></i> Commercial Trucking (IRP)
              <br />
              <i class="icon-services-list"></i> Plate &amp; Vehicle Registration
            </span>
            <br />
            <span v-for="(amenity,index) in dataPrimaryCard.amenities" :key="index">
              <i class="icon-services-list"></i>
              {{ amenity }}
            </span>
          </p>

        <br />
        <div v-if="showIWTMessage()">
           <h6>STATUS</h6>

          <hr />
          <WaitTimeCard
                :waitTime="this.getPrimaryCard.IWTavgWT"
                :capacity="this.getPrimaryCard.IWTcapacity" 
                :lastUpdated="this.getPrimaryCard.IWTlastUpdated" 
                :error="this.getPrimaryCard.IWError"
                :errorMessage="this.getPrimaryCard.IWTErrorMessage"
                />
        </div>
         
          
          <h6>HOURS</h6>
          <hr />
          <p>
            
            <template v-if="dataPrimaryCard.officeTypes === 'kiosk'">
              <!-- Handle Kiosk hours, holidays -->
              <strong v-if="this.rootStore.isStateHoliday === false">Currently {{ dataPrimaryCard.normalOfficeStatus }}.</strong>
              <template v-if="dataPrimaryCard.temporaryOfficeStatus !== 'Closed'"> Store hours are {{ dataPrimaryCard.normalHours }}</template>
              <em v-if="this.rootStore.isStateHoliday === true"><br/><br/>* Store hours are subject to change due to holidays.</em>
            </template>

            <template v-if="dataPrimaryCard.officeTypes !== 'kiosk'">
              <!-- handle non-kiosk hours,holidays -->
              
              <template v-if="this.rootStore.isStateHoliday === false && dataPrimaryCard.temporaryOfficeStatus !== 'Closed'">Currently <strong>{{ dataPrimaryCard.normalOfficeStatus }}.</strong> Hours are {{ dataPrimaryCard.normalHours }}</template>
              
              <strong v-if="this.rootStore.isStateHoliday === true">Currently closed for the holiday. </strong>
              <br/>
              <template v-if="dataPrimaryCard.temporaryOfficeStatus !== 'Closed' && this.rootStore.isStateHoliday === true"> Normal hours are {{ dataPrimaryCard.normalHours }}</template>
              <!-- <em v-if="this.rootStore.isStateHoliday === false"><br/>{{ this.IWTmessageOrTime }}</em> -->
            </template>
          
          </p>
          <br />

          <h6>ADDRESS</h6>
          <hr />
          <div class="row">
            <div class="col-sm-4">
              <div class="thumbMap" style="margin-top:3px;" v-on:click="zoomBigMapToOffice">
                <img
                  :src="this.mapImage"
                  alt="Map image of this location"
                />
                <em>Zoom to location</em>
              </div>
              <em></em>
            </div>

            <div class="col-sm-8">
              <p>
                {{ dataPrimaryCard.address}}
                <br />
                {{ dataPrimaryCard.city}}, NC {{ dataPrimaryCard.zip}}
                <br />
                <em>In {{ dataPrimaryCard.counties }} County</em>
              </p>

              <p>
                <template v-if="dataPhoneNumber">
                Phone:
                <a class="text-dark" :href="dataPhoneNumberLink">{{ dataPhoneNumber }}</a>
                <br />Fax:
                
                </template>

                <template v-if="dataFaxNumber">
                  <a class="text-dark" :href="dataPhoneNumberLink">{{ dataFaxNumber }}</a>               
                  <br />
                </template>

                <template v-if="dataURL">
                  <a :href=dataURL >{{dataURL}}</a>
                </template>

                <template v-if="dataURL"><br>
                   <a :href=dataURLsecond >{{dataURLsecond}}</a>
                </template>
              </p>

           
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="card-footer" v-if="dataPrimaryCard.temporaryOfficeStatus !== 'Closed'">
      <div class="row no-gutters">
        <div class="col-lg-4">
          <a class="btn btn-outline-primary"
            style="cursor:pointer"
            v-if="dataPhoneNumberLink"
            :href="this.dataPhoneNumberLink"
          >Call Office</a>
        </div>
        <div class="col-lg-4" v-if="dataPrimaryCard.officeTypes === 'license'" >
          <a
           class="btn btn-outline-primary"
            href="/dmv/license-id/driver-license-appointments/Pages/default.aspx"
            target="_blank"
          >Make Appointment</a>
        </div>
        <div class="col-lg-4">
          <a
            class="btn btn-outline-primary"
            :href="this.dataDrivingDirectionsLink"
            target="_blank"
          >Driving Directions</a>
        </div>
      </div>
    </div>
  </div>
</template>




<script>
import { useRootStore } from "../store";
import WaitTimeCard from './waitTimeCard.vue';

export default {
  components: {
    WaitTimeCard
  },
  data() {
    return {
      rootStore: useRootStore(),
      isCardWide: false, // Put card in wide-view?
      dataDrivingDirectionsLink: "",
      dataPrimaryCard: "",
      mapImage: "",
      dataPhoneNumberLink: "",
      dataPhoneNumber: "",
      dataFaxNumber:"",
      dataURL:"",
      dataURLsecond:"",
      IWTmessageOrTime:""
    };
  },
  methods: {
    showIWTMessage() {
      // Only show IWT message for license offices (not plate, kiosk, irp, lt), when feature is enabled, office is open, and iwtLoadWindow is true
      if (
        this.rootStore.allowedDateTime?.enableWaitTimesFeature &&
        this.getPrimaryCard.officeTypes === "license" &&
        this.getPrimaryCard.normalOfficeStatus === "Open" &&
        this.getIsStateHoliday === false 
        && this.getIWTLoadWindow === true
      ) {
        return true;
      }
      return false;

    },
    makeIWTmessage() {
      // console.log(this.getPrimaryCard.officeTypes)

      // These first two handle when IWT rules say don't display wait time.
      if (this.rootStore.allowedDateTime?.enableWaitTimesFeature) {
        // Handle "We have a special message, and we're outside of the IWT hours DMV wants to show"
        if (this.rootStore.iwtLoadWindow === false && this.getPrimaryCard.normalOfficeStatus === "Open" && this.getPrimaryCard.Custom !== null && this.getPrimaryCard.Custom !== undefined) {
          console.log("Showing custom message for IWT Office" + this.getPrimaryCard.IWTOffice)
          return this.IWTmessageOrTime = this.getPrimaryCard.Custom
        }

        // Handle "We're outside the IWT hours window"
        if (this.rootStore.iwtLoadWindow === false && this.getPrimaryCard.officeTypes === 'license' && this.getPrimaryCard.normalOfficeStatus === "Open") {
          return this.IWTmessageOrTime = "Walk-in wait times are not displayed Monday-Friday before 9am."
        }


        // The rest are here for when IWT rules allow it to be displayed:

        // Handle "The office is closed, or it is a non-license, non-plate office
        if (this.getPrimaryCard.normalOfficeStatus !== "Open" || (this.getPrimaryCard.officeTypes !== "plate" && this.getPrimaryCard.officeTypes !== "license")) {
          return this.IWTmessageOrTime = ""
        }

        // Handle "Show a custom message if one is provided"
        if (this.getPrimaryCard.normalOfficeStatus === "Open" && this.getPrimaryCard.Custom !== null && this.getPrimaryCard.Custom !== undefined) {
          console.log("Showing custom message for IWT Office " + this.getPrimaryCard.IWTOffice)
          return this.IWTmessageOrTime = this.getPrimaryCard.Custom
        }

        // For Plate and License offices with no time provided.
        if (this.getPrimaryCard.normalOfficeStatus === "Open" && (this.getPrimaryCard.officeTypes === "plate" || this.getPrimaryCard.officeTypes === "license") && (this.getPrimaryCard.IWTavgWT === "" || this.getPrimaryCard.IWTavgWT === null || this.getPrimaryCard.IWTavgWT === undefined)) {
          return this.IWTmessageOrTime = "No wait time available for this location."
        }

        // Handle showing actual hours/minutes of wait time if provided
        if (this.getPrimaryCard.normalOfficeStatus === "Open" && (this.getPrimaryCard.IWTavgWT !== undefined && this.getPrimaryCard.IWTavgWT !== null && this.getPrimaryCard.IWTavgWT !== "" && this.getPrimaryCard.normalOfficeStatus !== "Closed")) {
          return this.IWTmessageOrTime = "Current average wait time is " + this.getPrimaryCard.IWTavgWT + " from check in."
        }

        else {
          return this.IWTmessageOrTime = ""
        }
      } else {
          return this.IWTmessageOrTime = ""
        }

    },

    makeMapImage() {
      var baseUrl = "https://dev.virtualearth.net/REST/V1/Imagery/Map/Road/";
      var Lat = this.getPrimaryCard.lat;
      var Long = this.getPrimaryCard.lon;
      var bingKey = this.rootStore.mapAPIkey;

      this.mapImage =
        baseUrl +
        Lat +
        "%2C" +
        Long +
        "/10?mapSize=150,100&format=png&pushpin=" +
        Lat +
        "%2C" +
        Long +
        ";66;&key=" +
        bingKey;
    },
    makePhoneNumberLink() {  // Hide for closed offices or non-license/plate offices
      if (
        this.getPrimaryCard.normalOfficeStatus !== "Open" ||
        (this.getPrimaryCard.officeTypes !== "plate" && this.getPrimaryCard.officeTypes !== "license")
      ) {
        return false;
      }

      // Show custom message if outside IWT window and custom exists
      if (
        this.rootStore.iwtLoadWindow === false &&
        this.getPrimaryCard.Custom != null
      ) return true;
      this.dataPhoneNumberLink = ""

      if (
        this.getPrimaryCard.phone !== null &&
        this.getPrimaryCard.phone !== "undefined"
      ) {
        var _linkstart = "tel:";

        var _fixedphoneNumber = this.getPrimaryCard.phone[0].replace(") ",")-");        
        this.dataPhoneNumberLink = _linkstart + _fixedphoneNumber;
      }
    },
    makePhoneNumber() {
      // Clear out the old number first, in case the old location doesn't have a number.
      this.dataPhoneNumber = ""

      if (this.getPrimaryCard.phone !== null) {
        var _fixedphoneNumber = this.getPrimaryCard.phone[0].replace(") ",")-");        
        this.dataPhoneNumber = _fixedphoneNumber; // Safari doesn't like spaces in phone numbers
      }
    },
    makeFaxNumber() {
      // Clear out the old fax first, in case the old location doesn't have a number.
      this.dataFaxNumber = ""
      if (this.getPrimaryCard.fax !== null) {
        this.dataFaxNumber = this.getPrimaryCard.fax[0];
      }
    },
    makeWebSiteURL(){
      this.dataURL = ""
      this.dataURLsecond = ""
     
      if (this.getPrimaryCard.website !== null ) {
        this.dataURL = this.getPrimaryCard.website[0];
        this.dataURLsecond = this.getPrimaryCard.website[1];
      }
    },
    makeDrivingDirectionsLink() {
      if (this.getPrimaryCard.address !== null) {
        // https://www.bing.com/maps?where1=1100%20NEW%20BERN%20AVENUE%20RALEIGH,%20NC%2027697&rtop=0~1~0
        var _add = this.getPrimaryCard.address;
        var _zip = this.getPrimaryCard.zip;
        var _cit = this.getPrimaryCard.city;
        // var _url = "https://www.bing.com/maps?where1=";
        var _url = "https://www.bing.com/maps?q=.";
        var _end = "&rtop=0~1~0";

        this.dataDrivingDirectionsLink =
          _url + _add + "%20" + _cit + ",NC%20" + _zip + _end;

      }
    },
    zoomBigMapToOffice() {
      var _zoomCoords = {};

      _zoomCoords.Lat = this.dataPrimaryCard.lat;
      _zoomCoords.Long = this.dataPrimaryCard.lon;

      this.rootStore.SET_ZOOMED_LOCATION(_zoomCoords);
      document
        .getElementById("dmvLocsDashboard")
        .scrollIntoView({ behavior: "smooth", block: "center" });
    },
  },
  watch: {
    getPrimaryCard: function() {
      
      if (this.getPrimaryCard.length === 0) {
          // Hide primary card if nothing is selected
          this.dataPrimaryCard = "";

        } else {
         // this.queryWebSiteURL();
          this.dataURL = "",
          this.dataURLsecond = "",
          this.makeMapImage();
          this.makePhoneNumberLink();
          this.makePhoneNumber();
          this.makeFaxNumber();
          this.makeWebSiteURL();
          this.makeDrivingDirectionsLink();
          this.makeIWTmessage();
          this.dataPrimaryCard = this.getPrimaryCard; // Since we're shuffling big objects, need to put this in Vue's data instance
        }

        // Rules to decide if we make card wider 
        // if (this.getPrimaryCard.notes !== "" && this.getPrimaryCard.temporaryOfficeStatus !== "Appointment Only" && this.getPrimaryCard.temporaryOfficeStatus !== "Closed") {
        //   this.isCardWide = true;
        // } else {
        //   this.isCardWide = false;
        // }


        if (this.getPrimaryCard.notes !== "") {
          this.isCardWide = true;
        } else {
          this.isCardWide = false;
        }    
      },

      'getPrimaryCard.IWTavgWT'() {
        this.makeIWTmessage();
      }
  },
  computed: {
  
    getPrimaryCard() {
      return this.rootStore.primaryCard;
    },
    getIsStateHoliday() {
      return this.rootStore.isStateHoliday;
    },
    getIWTLoadWindow() {
      return this.rootStore.iwtLoadWindow;
    }
  }
};
</script>